import React from 'react'
import PassowrdAjax from './components/PassowrdAjax'
import LogoJobmatrix from '../app/components/PageHelpers/LogoJobmatrix'

const AppPassword = () => {
    return (
        <div className="jm-app jm-app-pwd">
            <div className='jm-page jm-page-pwd'>
                <div className="jm-page-header">
                    <LogoJobmatrix />
                    {/* Dieselbe Klasse wie der Kopf des MatchMeista (PageHeaderSkeleton):
                        die Gestaltung haengt an ihr, nicht am Tag. h1 bleibt — die
                        Passwort-Maske ist die ganze Seite. */}
                    <h1 className="jm-title-matrix">+++ Passwort anfordern +++</h1>
                </div>

                <div className="jm-page-main">
                    <PassowrdAjax />
                </div>

                <div className="jm-page-footer" />
            </div>
        </div>
    )
}

export default AppPassword